import { Link } from 'react-router-dom';
import { getHotArticles } from '@/mocks/articles';

export default function HotTopics() {
  const hotArticles = getHotArticles().slice(3);

  return (
    <section className="bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-1.5 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">热门追踪</h2>
          </div>
          <span className="flex items-center gap-1 text-sm text-foreground-500">
            <i className="ri-fire-fill w-4 h-4 flex items-center justify-center text-primary-500"></i>
            实时热点
          </span>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.slice(0, 4).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden border border-secondary-200/70 hover:border-primary-300/60 transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  title={article.title}
                />
              </div>
              <div className="p-4">
                <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">{article.category}</span>
                <h3 className="text-sm font-heading font-semibold text-foreground-900 line-clamp-2 mt-2 group-hover:text-primary-600 transition-colors duration-200 leading-snug">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 mt-2 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{article.publishDate}</span>
                  <span className="whitespace-nowrap">{article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万` : article.viewCount.toLocaleString()} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}